import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { SetUserDashboardDefault } from '@fnModels/business';
import { DefaultDashboardSelection } from '@models/businesses';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class BusinessesServiceFunc {
	constructor(private fns: AngularFireFunctions) {}

	updateUserDashboardDefault = (
		defaultSelection: DefaultDashboardSelection,
	): Observable<void> => {
		const callable = this.fns.httpsCallable(
			'businessUser_updateUserDashboardDefault',
		);
		const newBusinessModelRequest: SetUserDashboardDefault = {
			defaultFilter: defaultSelection,
		};

		return callable(newBusinessModelRequest);
	};
}
